import React,{useState} from 'react'
import IncomesForm from './components/IncomesForm'
const IncomeEdit = () => {
    const [mode,setMode] = useState('Editing');
    return (
        <div>
            <IncomesForm mode={mode} setMode={setMode} />
        </div>
    )
}

export default IncomeEdit